import type { BehaviorSubject, Observable } from 'rxjs';

export enum TimeFilter {
    FiveMinute = 'fiveMinute',
    Hour = 'hour',
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year',
    AllMeasurements = 'allMeasurements',
    DatePicker = 'datePicker',
}

export type FilterClickType = Exclude<TimeFilter, TimeFilter.AllMeasurements>;

export interface GraphAdapter {
    xAxis: {
        originalScale: (value: Date) => number;
        scale: {
            domain: () => [Date, Date];
        };
    };
    zoom: {
        zoom: {
            transform: (...args: unknown[]) => unknown;
        };
        zoomToScale: (days: number) => void;
        zoomTransition: () => {
            call: (fn: (...args: unknown[]) => unknown, ...args: unknown[]) => unknown;
        };
    };
}

export interface DataSetAdapter {
    currentSensor$: BehaviorSubject<string | null>;
    dateRange: {
        toggleTimePanning: () => void;
    };
    setVisibleMinMax: (min: number, max: number) => void;
}

export type FilterActionFactoryContext = {
    dataSet: DataSetAdapter;
    graph: GraphAdapter;
    showDateRangePicker$: BehaviorSubject<boolean>;
};

export type FilterActionFactory = (ctx: FilterActionFactoryContext) => Observable<void>;
